import AbstractSlopedRectangle from "./AbstractSlopedRectangle";

export default class SlopedRectangleFlipHorizontal extends AbstractSlopedRectangle {
	static NAME = "sloped-rectangle-flip-horizontal";

	get_name() {
		return SlopedRectangleFlipHorizontal.NAME;
	}
}
